export default "__VITE_ASSET__BpINtKhP__"